import {useListView} from '../../core/ListViewProvider'
import {MainOrdersListToolbar} from './MainOrderListToolbar'
import {UsersListGrouping} from './MainOrderListGrouping'

const MainOrdersListHeader = () => {
  const {selected} = useListView()
  return (
    <div className='card-header border-0 pt-6'>
      {/* <OrdersListSearchComponent /> */}
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        {selected.length > 0 ? <UsersListGrouping /> : <MainOrdersListToolbar />}
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {MainOrdersListHeader}
